(function quickFixLinks() {
	const modules = document.querySelectorAll('[data-quick-fix-links]');

	for (const module of modules) {
		const aTag = module.querySelectorAll('a');
		for (const link of aTag) {
			if (link.classList.length <= 0) {
				link.classList.add('link--wave');
			}
		}
	}
})();
